import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [username, setUsername] = useState('');
  const [showMenu, setShowMenu] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const fetchUsername = async () => {
      try {
        const response = await fetch('/api/v1/username');
        const data = await response.json();
        setUsername(data.username);
      } catch (error) {
        console.error('Error fetching username:', error);
      }
    };

    fetchUsername();
  }, []);

  return (
    <header className="header">
      <div className="logo">
        <span className="logo-1">Ne</span>
        <span className="logo-2">X</span>
        <span className="logo-3">t</span>
        <span className="logo-4">Banker</span>
      </div>
      <div className="header-right">
        <nav>
          <a href="/" className={location.pathname === '/' ? 'active' : ''}>Home</a>
          <a href="/reports" className={location.pathname === '/reports' ? 'active' : ''}>Reports</a>
        </nav>
        {username && <div className="separator"></div>}
        <div className="user-profile" onMouseEnter={() => setShowMenu(true)} onMouseLeave={() => setShowMenu(false)}>
          <span>{username}</span>
          {showMenu && (
            <div className="dropdown-menu">
              <a href="/api/v1/logout">Logout</a>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;